module.exports = __webpack_public_path__ + "img/ring_g_e_0_null@3x.f24c48e3.png";